"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/index.js";
import { IconButton } from "../IconButton/index.js";
import { popupHeaderVariants } from "./PopupHeader.variants.js";
import { usePopupHeaderContext } from "./PopupHeaderContext.js";
const PopupHeader_Close_PopupHeaderClose = /*#__PURE__*/ forwardRef(function({ className, buttonClassName, slots, 'aria-label': ariaLabel = 'Close', onClick }, ref) {
    const { scrim } = usePopupHeaderContext();
    const { closeButton } = popupHeaderVariants();
    return /*#__PURE__*/ jsx(IconButton, {
        ref: ref,
        iconName: "close",
        type: scrim ? 'secondary' : 'primary',
        emphasis: "bold",
        shadow: true,
        size: "sm",
        "aria-label": ariaLabel,
        onClick: onClick,
        className: className,
        buttonClassName: cn(closeButton(), buttonClassName),
        slots: slots
    });
});
PopupHeader_Close_PopupHeaderClose.displayName = 'PopupHeader.Close';
export { PopupHeader_Close_PopupHeaderClose as PopupHeaderClose };
